/* Publish by EComposer at 2026-10-23 11:45:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w7ex5rmjra"]=  window.__ectimmers["ecom-w7ex5rmjra"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-w7ex5rmjra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w7ex5rmjra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-605cfupz0aa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-605cfupz0aa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wicbw72s7ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wicbw72s7ei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n70ql5673qg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n70ql5673qg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tnpa7p8kqx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tnpa7p8kqx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y5b6dcwh5ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y5b6dcwh5ff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-68xcfugoh0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-68xcfugoh0k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j1bmodv2rqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j1bmodv2rqd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3y0cujhfayo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3y0cujhfayo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3ppyuzhqst').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3ppyuzhqst', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rgt1wqkc06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rgt1wqkc06', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9y7s34sog4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9y7s34sog4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jq1jg63zee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jq1jg63zee', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-surs7dw0okn"]=  window.__ectimmers["ecom-surs7dw0okn"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-surs7dw0okn"]["2oai9s3xu"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-surs7dw0okn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-surs7dw0okn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqgrn49cjcp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqgrn49cjcp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4lirt724vi8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4lirt724vi8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7he0iw4e35c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7he0iw4e35c', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gl93mfbzssf"]=  window.__ectimmers["ecom-gl93mfbzssf"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-gl93mfbzssf"]["x7am4u2q8"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-gl93mfbzssf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gl93mfbzssf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q0xc9mui93').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q0xc9mui93', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uwz89swu36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uwz89swu36', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pv9k386wxsi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pv9k386wxsi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tzr29dy3s0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tzr29dy3s0q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7zzbh2g4vz4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7zzbh2g4vz4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nll5g66f0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nll5g66f0g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxh0kqhvgpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxh0kqhvgpg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2npdqr94nl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2npdqr94nl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-83o6rgb21e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-83o6rgb21e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bcq3plenrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bcq3plenrl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85bfmsff0sv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85bfmsff0sv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xrc65gq01w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xrc65gq01w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-50ok9qbw0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-50ok9qbw0o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fk7bkv66non').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fk7bkv66non', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}